import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDevelopmentsService } from "services/DevelopmentsService";
import { GuidSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  DevelopmentSelectModels: new Array<GuidSelectModel>(),
  ServiceChargeDevelopmentModels: new Array<GuidSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
  ServiceChargeLastUpdatedTme: new Date(),
};

export const developmentSelectSlice = createSlice({
  name: "developmentSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDevelopmentSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getDevelopmentSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getDevelopmentSelectModels.fulfilled, (state, action) => {
        if (action.meta.arg === true) {
          state.ServiceChargeDevelopmentModels = action.payload;
          state.ServiceChargeLastUpdatedTme = new Date();
        } else {
          state.DevelopmentSelectModels = action.payload;
          state.LastUpdateTime = new Date();
        }
        state.Loading = false;
      });
  },
});

export const getDevelopmentSelectModels = createAsyncThunk(
  "Developments/GetSelectModels",
  async (isServiceChargeOnly?: boolean) => {
    const developmentsService = container.get<IDevelopmentsService>(SERVICE_TYPES.DevelopmentsService);
    return await developmentsService.getSelectModels(isServiceChargeOnly);
  }
);

export const selectDevelopmentSelectModels = (state: RootState) => {
  return state.developmentSelect.DevelopmentSelectModels;
};
export const selectServiceChargeDevelopmentModels = (state: RootState) => {
  return state.developmentSelect.ServiceChargeDevelopmentModels;
};
export const selectLoading = (state: RootState) => {
  return state.developmentSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.developmentSelect.LastUpdateTime;
};
export const selectServiceChargeLastUpdatedTime = (state: RootState) => {
  return state.developmentSelect.ServiceChargeLastUpdatedTme;
};

export default developmentSelectSlice.reducer;
